import { createContext, useContext } from "react";
import { Client, reclaim } from "../reclaim-api/index";

export const DomainContext = createContext<Client>(reclaim);

export function useDomainContext() {
  return useContext<Client>(DomainContext);
}
